import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn.ts'

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-card border border-line bg-surface shadow-card', className)} {...props} />
}

export function CardHeader({
  title,
  aside,
  className,
}: {
  title: ReactNode
  aside?: ReactNode
  className?: string
}) {
  return (
    <div className={cn('mb-4 flex flex-wrap items-baseline justify-between gap-2', className)}>
      <h2 className="font-display text-[17px] font-semibold">{title}</h2>
      {aside}
    </div>
  )
}
